import type { SVGProps } from 'react';
const SvgLodge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={0.5}
      d="M12.462 4.198a.83.83 0 0 1 1.076 0l9.167 7.778a.832.832 0 1 1-1.076 1.27l-.851-.722V19A2.777 2.777 0 0 1 18 21.778H8A2.777 2.777 0 0 1 5.222 19v-6.476l-.85.723a.833.833 0 0 1-1.078-1.271zM6.889 11.11V19A1.11 1.11 0 0 0 8 20.111h10A1.11 1.11 0 0 0 19.111 19v-7.889l-6.11-5.185z"
    />
  </svg>
);
export default SvgLodge;
